import React, { useState } from "react";
import Share from "../assets/icons/Share";
import { t } from "i18next";
import { post } from "../network/api";
import { ToastContainer, toast } from "react-toastify";
const Cta = () => {
  const [isLoading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  async function handleLogin() {
    try {
      setLoading(true);
      if (email === "") {
        setLoading(false);
        toast.error("Please enter email", {
          position: "bottom-center",
          autoClose: 3000,
        });
        return;
      }
      var data = await post("customer/newsletter", {
        email: email,
      });

      setLoading(false);
      toast.success("Newsletter signed up successfully!", {
        position: "bottom-center",
        autoClose: 3000,
      });
    } catch (e) {
      setLoading(false);
      toast.error( e, {
        position: "bottom-center",
        autoClose: 3000,
      });
    }
  }

  return (
    <div>
      <ToastContainer />

      <section className="bg_image_yellow">
        <div className="wrapper">
          <div className="cta_grid">
            <div className="cta_title">
              <h2 className="subtitle_common">
                {t("get_the_latest")}{" "}
                <span className="text-primary">{t("news_and_offers")}</span>
              </h2>
              <p className="para_common">
                {t(
                  "subscribe_to_our_newsletter_and_be_the_first_to_know_about_new_features_promotions_and_important_announcements"
                )}
              </p>
            </div>
            <div className="cta_input">
              <input
                type="email"
                className="input_cta"
                name="email"
                id="email"
                placeholder={t("enter_your_email_here")}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="btn btn-primary" onClick={handleLogin}>
                <span>{t("subscribe")}</span> <Share />
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cta;
